import { z } from "zod";

const runtimeConfigSchema = z.object({
  VITE_PUBLIC_API_BASE_URL: z.url().optional(),
  VITE_PUBLIC_TURNSTILE_SITE_KEY: z.string().trim().min(1).optional(),
  VITE_PUBLIC_GTM_ID: z
    .string()
    .trim()
    .regex(/^GTM-[A-Z0-9]+$/)
    .optional(),
  VITE_GOOGLE_MAPS_BROWSER_API_KEY: z.string().trim().min(1).optional(),
  VITE_STRIPE_PUBLISHABLE_KEY: z
    .string()
    .trim()
    .regex(/^pk_(test|live)_/)
    .optional(),
});

export type RuntimeConfig = Readonly<{
  apiBaseUrl?: URL;
  turnstileSiteKey?: string;
  googleTagManagerId?: string;
  googleMapsBrowserApiKey?: string;
  stripePublishableKey?: string;
}>;

export function readRuntimeConfig(environment: Record<string, unknown>): RuntimeConfig {
  const parsed = runtimeConfigSchema.parse(environment);
  return {
    ...(parsed.VITE_PUBLIC_API_BASE_URL
      ? { apiBaseUrl: new URL(parsed.VITE_PUBLIC_API_BASE_URL) }
      : {}),
    ...(parsed.VITE_PUBLIC_TURNSTILE_SITE_KEY
      ? { turnstileSiteKey: parsed.VITE_PUBLIC_TURNSTILE_SITE_KEY }
      : {}),
    ...(parsed.VITE_PUBLIC_GTM_ID ? { googleTagManagerId: parsed.VITE_PUBLIC_GTM_ID } : {}),
    ...(parsed.VITE_GOOGLE_MAPS_BROWSER_API_KEY
      ? { googleMapsBrowserApiKey: parsed.VITE_GOOGLE_MAPS_BROWSER_API_KEY }
      : {}),
    ...(parsed.VITE_STRIPE_PUBLISHABLE_KEY
      ? { stripePublishableKey: parsed.VITE_STRIPE_PUBLISHABLE_KEY }
      : {}),
  };
}

export const runtimeConfig = readRuntimeConfig(import.meta.env);
